const state = {
  idUser: null,
  updatedAt: null,
  completedAt: null,
  // VALIDATION
  validation: [
    { name: "YOUR_INFORMATIONS", status: false },
    { name: "YOUR_HOME", status: false },
    { name: "ANNUAL_RECIPE", status: false },
    { name: "REAL_ESTATE", status: false },
    { name: "SAVINGS", status: false },
    { name: "SPENDING_NO_TAXES", status: false },
    { name: "CREDITS", status: false },
    { name: "TAXES", status: false },
    { name: "ISF", status: false },
    { name: "RETREAT", status: false },
    { name: "INFLUENCE", status: false },
    { name: "FOLLOWING", status: false },
    { name: "KNOWLEDGE", status: false },
    { name: "PERSPECTIVE", status: false },
    { name: "ESG", status: false },
  ],
  // YOUR INFORMATIONS
  birthdate: "",
  job: "",
  csp: "",
  maritalStatus: "",
  // YOUR HOME
  childs: [],
  // ANNUAL RECIPE
  directIncome: { val: null, cur: "EUR" },
  secondIncome: { val: null, cur: "EUR" },
  // REAL ESTATE
  mainEstate: { val: null, cur: "EUR", type: null },
  secondaryEstates: [],
  rentalProperties: [],
  isSCPI: false,
  scpi: { value: null, cur: "EUR", type: null },
  // SAVINGS
  savings: [],
  // GFR
  gfr: {
    nbObjects: null,
    isMetals: null,
    isReceivables: null,
    isOtherEstates: null,
  },
  // SPENDING NO TAXES
  spendingNoTaxes: { value: null, cur: "EUR" },
  periodicity: null,
  // CREDITS
  credits: [],
  overallDebtPercentage: "",
  // TAXES
  taxes: {
    value: null,
    cur: "EUR",
    nbFiscalParts: 1,
    countryForTaxes: "France",
  },
  // ISF
  isf: {
    amount: null,
    cur: "EUR",
  },
  // RETREAT
  retreat: {
    month: null,
    year: null,
    PERP: [],
  },
  // INFLUENCE
  influence: {
    motivation: null,
    conselors: [],
  },
  // FOLLOW
  follow: {
    rate: null,
    nbContractCounselor: 0,
    nbPatrimonialCounselor: 0,
  },
  // KNOWLEDGE
  knowledge: {
    diploma: null,
    level: null,
    age: null,
    country: null,
    products: [],
    investedProducts: [],
    managements: [],
  },
  // PERSPECTIVE
  perspective: {
    perspective: null,
    objective: [],
    riskDegree: null,
    risingMarket: null,
    assetsEstimate: null,
    investmentsEstimate: null,
  },
  // ESG
  esg: {
    interestedBySustainability: false,
    acceptLowerPerformance: false,
    durabilite: [],
  },
  // TOTAL
  total: {
    incomes: null,
    loans: null,
    savings: null,
    immobilier: null,
  },
  // ADVISOR CHECK
  advisorCheck: {
    advisorConsistencyCheck: null,
    advisorCompletenessCheck: null,
    advisorWarningSentToClient: null,
  },
};

export default state;



// WEBPACK FOOTER //
// ./src/common/store/PatrimonialEstate/state.js